import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { alertActions } from '../../../../../_actions/alert.actions'
import { usersService } from '../../../../../_services/users.service'
import { Alert, Button, Col, Modal, Row, Spinner } from 'react-bootstrap'

export default function ActivateModal({ user, show, handleClose }) {
  const dispatch = useDispatch(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleCloseModal = () => {
    setError('')
    setLoading(false)
    setTimeout(() => {
      handleClose(false)
    }, 100);
  }
  
  const handleReactivate = () => {
    setError('')
    setLoading(true)

    usersService.reactivateUser(user.userId)
      .then(() => {
        handleClose(true)
        dispatch(alertActions.success('User reactivated.'));
      })
      .catch(() => {
        setError('Could not reactivate user at this time. Please try again.');
      })
      .then(() => {
        setLoading(false)
      })
  }

  const name = user ? `${user.firstName} ${user.lastName}` : null;

  return (
    <Modal show={show} onHide={handleCloseModal} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Re-activate User</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        { error && <Alert variant='danger'>{ error }</Alert> }
        <Row>
          <Col>
              <p>{`By re-activiting, ${name} will be able to login and have access to the platform.`}</p>
              <p>Are you sure you want to re-activate the user?</p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className='w-100 justify-content-end'>
          <Col xs='4'>
            <Button disabled={loading} onClick={handleReactivate} block variant='success'>
              { loading ? <Spinner size='sm' animation='border' /> : 'Yes, re-activate'}
            </Button>
          </Col>
          <Col xs='3'>
            <Button disabled={loading} onClick={handleCloseModal} block variant='secondary'>No, cancel</Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}
